import {
  DsTableLookupColumn,
  DsTableColumn,
} from 'src/app/shared/ds-table/TableColumn';
import { EsResponseModel } from '../../../shared/EsResponseModel';
import { DsTableColumnSizeEnum } from 'src/app/shared/ds-table/TableColumnConfig';
import { Lookup } from 'src/app/core/models/common/Lookup';

export interface ParticipantTemplateDto {
  ID: number;
  TemplateName: string;
  ServiceNameAr?: null;
  ServiceName?: null;
  ServiceURL?: string;
  ParticipantID?: number;
  ProcedureID: number;
  Template: string;
  TemplateDetails: string;
}

export class TemplateServicesResponse extends EsResponseModel<ParticipantTemplateDto> {}

export class AddOrUpdateTemplateServicesResponse extends EsResponseModel<ParticipantTemplateDto> {}

export class TemplateServicesListResponse extends EsResponseModel<
  ParticipantTemplateDto[]
> {}

export class ParticipantTemplate {
  id: number;

  @DsTableColumn({
    key: 'trTemplateName',
    size: DsTableColumnSizeEnum.Third,
  })
  name: string;
  // serviceNameEn: string;
  // serviceNameAr: string;

  @DsTableLookupColumn({
    key: 'trTemplateServiceName',
  })
  service: Lookup;

  url: string;
  participantId: number;
  procedureId: number;
  template: string;
  templateDetails: string;
}
